export const WHITE = '#fff'
export const PURPLE = '#a64Ac9'
export const RED = '#e91721'
export const YELLOW = '#fccd04'
export const ORANGE = '#ff6e29'
export const PINK = '#ffb48f'
export const CHAMPAGNE = '#f5e6cc'
export const BLUE = '#17e9e0'
export const BLACK = '#000'
